import {useIntl} from 'react-intl'
import {KTSVG} from '../../../helpers'
import {AsideMenuItemWithSub} from './AsideMenuItemWithSub'
import {AsideMenuItem} from './AsideMenuItem'
import {shallowEqual, useSelector} from 'react-redux'
import {UserModel} from '../../../../app/modules/auth/models/UserModel'
import {RootState} from '../../../../setup'

export function AsideMenuMain() {
  const intl = useIntl()
  const user: UserModel = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserModel
  return (
    <>
      <AsideMenuItem
        to='/dashboard'
        icon='/media/icons/duotune/art/art002.svg'
        title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
        fontIcon='bi-app-indicator'
      />
      {/* -------------------Support--------------- */}
      <AsideMenuItemWithSub
        to='/support'
        title='Support'
        fontIcon='bi-archive'
        icon='/media/icons/duotune/general/gen025.svg'
      >
        <AsideMenuItem
          to='/support/readymade'
          // dislpay={user.roleID === 2 ? '' : 'd-none'}
          title='Ready Made'
          hasBullet={true}
        />
        <AsideMenuItem
          to='/support/diy'
          // dislpay={user.roleID === 2 ? '' : 'd-none'}
          title='DIY'
          hasBullet={true}
        />
        <AsideMenuItem
          to='/support/modular'
          // dislpay={user.roleID === 2 ? '' : 'd-none'}
          title='Modular'
          hasBullet={true}
        />
      </AsideMenuItemWithSub>

      {/* --------------------------------- Organization -------------------------------------- */}

      {/* <AsideMenuItemWithSub
        to='/organization'
        title='Organization'
        fontIcon='bi-archive'
        icon='/media/icons/duotune/general/gen025.svg'
      >
        <AsideMenuItem
          to='/organization/employee'
          // dislpay={user.roleID === 2 ? '' : 'd-none'}
          title='Employee'
          hasBullet={true}
        />
        <AsideMenuItem
          to='/organization/user'
          // dislpay={user.roleID === 2 ? '' : 'd-none'}
          title='User'
          hasBullet={true}
        />
      </AsideMenuItemWithSub> */}

      {/* =================================================pipeline stage=================================================================== */}

      {/* <AsideMenuItem
        to='/pipeline-stage'
        title='Pipeline Stage'
        fontIcon='bi-layers'
        icon='/media/icons/duotune/general/gen025.svg'
      /> */}
      {/* =================================================Reason=================================================================== */}
      {/* 
      <AsideMenuItem
        to='/reasons'
        title='Reason '
        fontIcon='bi-chat-left'
        icon='/media/icons/duotune/communication/com012.svg'
      />
      <AsideMenuItem
        to='/product-service'
        // dislpay={user.roleID === 2 ? '' : 'd-none'}
        title='Product Service'
        // hasBullet={true}
        icon='/media/icons/duotune/communication/com006.svg'
        fontIcon='bi-person'
      /> */}

      {/* <AsideMenuItem
        to='/lead'
        // dislpay={user.roleID === 2 ? '' : 'd-none'}
        title='Lead'
        // hasBullet={true}
        icon='/media/icons/duotune/general/gen017.svg'
        fontIcon='bi-layers'
      /> */}
      {/* ==============================================master================================= */}

      {/* <AsideMenuItemWithSub
        to='/master'
        title='Master'
        fontIcon='bi-archive'
        icon='/media/icons/duotune/general/gen025.svg'
        // dislpay={
        //   user.roleID === 2 || (user.roleID === 3 && user.departmentID === 5) ? '' : 'd-none'
        // }
      >
        <AsideMenuItem to='/master/branch' title='Branch' hasBullet={true} />
        <AsideMenuItem to='/master/country' title='Country' hasBullet={true} />
        <AsideMenuItem to='/master/department' title='Department' hasBullet={true} />
        <AsideMenuItem to='/master/designation' title='Designation' hasBullet={true} />
        <AsideMenuItem to='/master/district' title='District' hasBullet={true} />
        <AsideMenuItem to='/master/documenttype' title='Document Type' hasBullet={true} />
        <AsideMenuItem to='/master/lead-type' title='Lead Type' hasBullet={true} />
        <AsideMenuItem to='/master/lead-status' title='Lead Status' hasBullet={true} />
        <AsideMenuItem to='/master/nationality' title='Nationality' hasBullet={true} />
        <AsideMenuItem to='/master/pipelines' title='Pipeline Master'    hasBullet={true}/>
        <AsideMenuItem to='/master/reason-type' title='Reason Type'   hasBullet={true} />
        <AsideMenuItem to='/master/state' title='State' hasBullet={true} />
        <AsideMenuItem to='/master/taluka' title='Taluka' hasBullet={true} />
      </AsideMenuItemWithSub> */}
    </>
  )
}
